import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";

// Core Components
import MDCModal from "../../../core/MDCModal";
import MDCButton from "../../../core/MDCButton";
import MDCLabel from "../../../core/MDCLabel";

// Assets
import carLogo from "../../../../assets/images/my_digital_car.svg";

// Icon Components
import CircleWithWarningIcon from "../../../iconComponents/CircleWithWarningIcon";
import CircleWithInfoIcon from "../../../iconComponents/CircleWithInfoIcon";
import MDCLoader from "../../../core/MDCLoader";

// Constants
import { SIGNING_PROCESSING_TYPE } from "../../../../constants/ManualRequestFormConstants";

const useStyles = makeStyles((theme) => ({
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
}));

const NPQESTypeSwitchModal = ({
  isLoading,
  show,
  processType,
  handleCloseQESTypeSwitchModal,
  handleVollmachtProcess,
}) => {
  const classes = useStyles();

  const isQesProcess = processType === SIGNING_PROCESSING_TYPE.QES;

  const getModalHeader = () => {
    return (
      <Grid container className={classes.headerCss}>
        <Grid item xs={7} className={classes.headerColor}>
          <MDCLabel
            label={isQesProcess ? "Achtung" : "Information"}
            variant="h6"
          />
        </Grid>
        <Grid item xs={5}>
          <img alt="My Digital Car" src={carLogo} width="95%" />
        </Grid>
      </Grid>
    );
  };

  const getModalBody = () => {
    return (
      <Grid container className={classes.headerCss} justifyContent="center">
        {isLoading ? (
          <Grid
            container
            justifyContent="center"
            height="17rem"
            alignItems={"center"}
          >
            <MDCLoader />
          </Grid>
        ) : (
          <>
            {isQesProcess ? <CircleWithWarningIcon /> : <CircleWithInfoIcon />}
            <Grid container marginY="2.5rem" marginX="1rem">
              <MDCLabel
                label={
                  isQesProcess
                    ? "Durch die Umstellung des Vollmachtsprozesses auf das QES‑Verfahren werden einige Daten im Reiter Fahrzeughalter gelöscht."
                    : "Da der Vollmachtsprozess auf ein teilautomatisiertes Verfahren umgestellt wird, müssen die Informationen im Reiter Fahrzeughalter erneut eingetragen werden."
                }
              />
            </Grid>
            <Grid container justifyContent="space-between">
              <Grid>
                <MDCButton
                  onClick={handleCloseQESTypeSwitchModal}
                  variant="outlined"
                  label="Abbrechen"
                />
              </Grid>
              <Grid>
                <MDCButton
                  onClick={handleVollmachtProcess}
                  variant="contained"
                  label="Bestätigen"
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    );
  };

  return (
    <MDCModal
      open={show}
      title={getModalHeader()}
      body={getModalBody()}
      size="sm"
    />
  );
};

export default NPQESTypeSwitchModal;
